import styled from 'styled-components';

const Container = styled.div`
  position: absolute;
  right: 15px;
  top: 15px;
`;

export default Container;
